import Axios from 'axios';
import {baseUrl} from './config';
let baseurl = process.env.NODE_ENV == 'dev' ?  '/api'  : baseUrl
const axios = Axios.create({
  baseURL: baseurl, // api的base_url
  timeout: 50000,    // 请求超时时间
  headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  // withCredentials: true // 所有请求携带cookie进行账号校验
});
export const safeFetch =  (url, options) => {
  let data = null;
  let method = options && options.method || 'GET';
	if(method == 'POST') {
		data = new FormData()
		if(options && options.params) {
			for (const key in options.params) {
				data.append(key, options.params[key]);
			}
		} 
		return axios({
			url: url,
			method: method.toLocaleLowerCase(),
			data
		});
	}
  if(method == 'GET') {
    return axios({
      url: url,
      method: method.toLocaleLowerCase(),
      params: options && options.query && options.query
    });
  }
}